import { Component, OnInit,  Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { CheckoutSubscriptionsService } from '../checkout-subscriptions.service';
import * as moment from 'moment';
import { DiscountsService } from 'src/app/services/discounts.service';
import { ToastService } from 'src/app/services/toast.service';
import { CountryService } from 'src/app/services/country.service';
import { InvoiceDetails } from 'src/app/interfaces/order';

@Component({
  selector: 'app-order-preview-tab',
  templateUrl: './order-preview-tab.component.html',
  styleUrls: ['./order-preview-tab.component.scss']
})
export class OrderPreviewTabComponent implements OnInit {
  code = '';
  applyingCode = false;
  codeError: string | undefined;
  public currentCountry: string = ''
  showConditions = false;
  @Input() finish_subscription: any;
  original_price: number | undefined;

  constructor(
    public checkout: CheckoutSubscriptionsService,
    private translate: TranslateService,
    private auth: AuthService,
    private discountService: DiscountsService,
    private toastr: ToastService,
    private countriesService: CountryService,
  ) { }

  ngOnInit(): void {
    console.log('this.finish_subscription',this.finish_subscription);
    this.auth.user.subscribe((user:any) => {
    this.currentCountry = user.country_code;
    });
  }

  applyCode () {
    this.codeError = undefined;
    if (this.code == '') {
        this.codeError = this.translate.instant('discount:course:coupon:expired');
        return;
    }

    this.applyingCode = true;

    this.discountService.getByCode(this.code)
      .then( (response: any) => {
        if (moment(response.data.valid_until).isBefore()) {
          this.codeError = this.translate.instant('discount:course:coupon:expired');
          return;
        }
        if (moment(response.data.valid_from).isAfter()) {
          this.codeError = this.translate.instant('discount:course:coupon:unavailable');
          return;
        }

        if (response.data.collection_id !== this.checkout.course!.id) {
          this.codeError = this.translate.instant('discount:course:coupon:wrong_course');
          return;
        }

        if (response.total_available > 0 && response.data.remaining_uses < 1) {
          this.codeError = this.translate.instant('discount:course:coupon:expired');
          return;
        }

        this.checkout.discount = response.data;
        this.original_price = this.checkout.subscription?.price;
        this.checkout.subscription!.price = this.getPriceWithDiscount(this.checkout.subscription!.price);
        this.checkout.calculateTotalAmount();
        this.toastr.showSuccess(this.translate.instant('discount:course:coupon:success'));
      })
      .catch( (error: any) => {
        this.codeError = this.translate.instant('discount:course:coupon:expired');
        this.checkout.subscription!.price = this.getPriceWithDiscount(this.checkout.subscription!.price);
      })
      .finally( () => {
        this.applyingCode = false;
      });
  };

  removeCode() {
    this.code = '';
    this.checkout.discount = null;
    this.checkout.subscription!.price = this.original_price!;
    this.checkout.calculateTotalAmount();
    this.codeError = undefined;
  }

  getSubscriptionEnds() {
    var format = 'MMMM Do YYYY';
    if (this.auth.getMe() && this.auth.getMe()!.language == 'nl') {
        format = 'D MMMM YYYY';
    }

    let date;
    if (this.finish_subscription){
       date=moment(this.finish_subscription)
    }else{
      date=moment()
    }

    return date.add(this.checkout.subscription!.subscription_days, 'days').format(format);
  };

  getSubscriptionStart() {
    var format = 'MMMM Do YYYY';
    if (this.auth.getMe() && this.auth.getMe()!.language == 'nl') {
        format = 'D MMMM YYYY';
    }
    let date;
    if (this.finish_subscription){
       date=moment(this.finish_subscription)
    }else{
      date=moment(this.checkout.order!.created_at)
    }

    return date.format(format);
  };

  toggleConditions() {
    this.showConditions = true;
  }

  getTotalDiscount(){
    return (this.checkout.order!.tax + this.checkout.order!.in_total)-this.getPriceWithDiscount(this.checkout.order!.tax + this.checkout.order!.in_total)
  }
  getTotalValue(){
    return this.getPriceWithDiscount(this.checkout.order!.tax + this.checkout.order!.in_total)
  }

  getTaxValue(){
   // return this.getTotalValue()*this.checkout.order!.tax_percentage;
   
   return this.getTotalValue() - this.getNetValue() ;
  }
  getTaxBycountry(){
    return this.countriesService.getCountryTax((this.checkout!.order!.invoice_details as InvoiceDetails).country_code);

    return this.countriesService.getCountryTax(this.currentCountry);
  }

  getNetValue(){
    let tax =  this.checkout.order!.tax_percentage ? this.checkout.order!.tax_percentage : this.getTaxBycountry() 
    //return (this.getTotalValue()-this.getTotalValue()*this.checkout.order!.tax_percentage)
    return (this.getTotalValue()/(1+tax))
  }
  
  getPriceWithDiscount(value: number) {
    if (!this.checkout.discount)
      return value;
    else if (this.checkout.discount.type === 'percentage')
      return value * (1 - this.checkout.discount.amount / 100);
    return Math.max(0, value - this.checkout.discount.amount);
  }
}
